const zone = 'Europe/Rome'
const dayFormatter = new Intl.DateTimeFormat('en-CA', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit' })
export const sessionDate = value => new Date(typeof value === 'string' && !/(Z|[+-]\d{2}:?\d{2})$/i.test(value) ? `${value.replace(' ', 'T')}Z` : value)
const dayKey = date => {
    const parts = Object.fromEntries(dayFormatter.formatToParts(date).map(part => [part.type, part.value]))
    return `${parts.year}-${parts.month}-${parts.day}`
}
function nextMidnight(start) {
    const key = dayKey(new Date(start))
    let low = start, high = start + 26 * 3600000
    // Rome civil days can last 23 or 25 hours during daylight-saving changes.
    while (high - low > 1) {
        const middle = Math.floor((low + high) / 2)
        if (dayKey(new Date(middle)) === key) low = middle
        else high = middle
    }
    return high
}
export function groupSessionDays(sessions = []) {
    const days = new Map()
    sessions.forEach(session => {
        if (!session.started_at) return
        let start = sessionDate(session.started_at).getTime()
        const seconds = Number(session.duration)
        if (!Number.isFinite(start) || !Number.isFinite(seconds) || seconds <= 0) return
        const end = start + seconds * 1000
        while (start < end) {
            const key = dayKey(new Date(start))
            const stop = Math.min(end, nextMidnight(start))
            if (!days.has(key)) days.set(key, { key, entries: [], seconds: 0 })
            days.get(key).entries.push({ id: `${session.id}-${start}`, start, end: stop, seconds: (stop - start) / 1000 })
            start = stop
        }
    })
    return [...days.values()].sort((a, b) => b.key.localeCompare(a.key)).map(day => {
        const ordered = [...day.entries].sort((a, b) => a.start - b.start)
        let end = 0
        ordered.forEach(entry => {
            day.seconds += Math.max(0, entry.end - Math.max(end, entry.start)) / 1000
            end = Math.max(end, entry.end)
        })
        day.entries.sort((a, b) => b.start - a.start)
        return day
    })
}
export function sessionDuration(seconds) {
    const value = Math.floor(seconds)
    if (value < 60) return `${value} s`
    const minutes = Math.floor(value % 3600 / 60)
    return value < 3600 ? `${minutes} min` : `${Math.floor(value / 3600)} h ${minutes} min`
}
